module.exports = __webpack_public_path__ + "static/media/media-05.7677b73e.png";